<template>
  <li class="map-card">
    <h3 class="h5">{{ contactLocation.locationName }}</h3>
    <h4 class="h6">{{ contactLocation.brandName }}</h4>
    <address>
      <div
          class="tel-tooltips d-flex justify-content-between"
          :class="{'mb-0': !contactLocation.phone && !contactLocation.offerSalesAndInstallation && !contactLocation.offerServices }"
      >
        <div>
          <pre v-html="contactLocation.address"></pre>
          <a :href="`tel: ${contactLocation.phone}`" v-if="contactLocation.phone">{{ contactLocation.phone }}</a>
        </div>
        <div class="d-flex align-items-end pb-1">
          <Tooltip :title="buttons.screwDriverIcon" v-if="contactLocation.offerSalesAndInstallation">
            <img :src="screwDriverIconPng" alt="screwDriverIconPng" class="d-inline-block me-2" width="30" height="24">
          </Tooltip>
          <Tooltip :title="buttons.service" v-if="contactLocation.offerServices">
            <img class="service-icon" :src="serviceIconPng" alt="serviceIconPng" width="24" height="24">
          </Tooltip>
        </div>
      </div>
      <p class="mb-0" v-if="contactLocation.email.address">
        <a :href="`mailto: ${contactLocation.email.address}`">{{ contactLocation.email.title }}</a>
      </p>
    </address>
    <ButtonTransparent v-if="contactLocation.showDetailsPage" hyperlink :href="contactLocation.button.link" :text="contactLocation.button.text" class="w-100" />
  </li>
</template>

<script>
import ButtonTransparent from "@/components/common/ButtonTransparent";
import ScrewDriverIcon from "@/assets/icons/screw-driver-icon";
import Service from "@/assets/icons/service-icon";
import ContactMapTooltip from "@/components/common/tooltips/ContactMapTooltip";
import Tooltip from "@/components/сontact-details-map/Tooltip";
import ServiceIconPng from '@/assets/images/service-icon.png'
import ScrewDriverIconPng from '@/assets/images/screw-driver.png'

export default {
  components: {Tooltip, ContactMapTooltip, Service, ScrewDriverIcon, ButtonTransparent},
  props: {
    contactLocation: {
      locationName: String,
      brandName: String,
      address: HTMLElement,
      isServiceArea: Boolean,
      phone: String,
      offerSalesAndInstallation: Boolean,
      offerServices: Boolean,
      email: {
        title: String,
        address: String
      },
      button: {
        link: String,
        text: String
      }
    },
    buttons: {
      screwDriverIcon: String,
      service: String
    }
  },
  data(){
    return {
      serviceIconPng: ServiceIconPng,
      screwDriverIconPng: ScrewDriverIconPng
    }
  }
}
</script>
